// App Message Posting Function
export default {
  methods: {
    postInternalPageView (path) {
      if (window.ga) {
        const pagePath = path.replace(/[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}/ig, 'guid')
        window.ga(`${this.$store.internalGoogleAnalyticsId}.send`, 'pageview', pagePath)
      }
    },
    postInternalGAEvent (group, eventName, label = '') {
      if (window.ga) {
        if (label !== '') {
          window.ga(`${this.$store.internalGoogleAnalyticsId}.send`, 'event', group, eventName, label)
        } else {
          window.ga(`${this.$store.internalGoogleAnalyticsId}.send`, 'event', group, eventName)
        }
      }
    }
  }
}
